export const FULLSTORY_ORG_ID = "WA342"

export const ELEMENT_IDS = {
  ANNOUNCEMENT_CONTAINER: "lumen-energy-announcements-container",
}
